import React, { useContext } from 'react';
import { IApkAssignmentContext, ApkAssignmentContext } from '../../../../apkAssignmentState/apkAssignmentContext';
import SearchField from 'components/SearchField/SearchField';
import classNames from 'classnames';
import style from './SearchFields.module.scss';

const SearchFields: React.FC = () => {
	const {
		changeSearchStringForAllCustomers,
		changeSearchStringForRestaurants,
		changeSearchStringForApk,
		searchStringForAllCustomers,
		searchStringForRestaurants,
		searchStringForApk,
		activeItemToDisplay,
	} = useContext<IApkAssignmentContext>(ApkAssignmentContext);

	const customerSearchFieldWrapperClasses = classNames(style.searchFieldWrapper, {
		[style.hide]: activeItemToDisplay !== 'customers',
	});
	const restaurantSearchFieldWrapperClasses = classNames(style.searchFieldWrapper, {
		[style.hide]: activeItemToDisplay !== 'restaurants',
	});
	const firmwareSearchFieldWrapperClasses = classNames(style.searchFieldWrapper, {
		[style.hide]: activeItemToDisplay !== 'apk',
	});

	return (
		<div className={style.container}>
			<div className={customerSearchFieldWrapperClasses}>
				<SearchField
					onChangeSelectSearchString={changeSearchStringForAllCustomers}
					searchString={searchStringForAllCustomers}
				/>
			</div>
			<div className={restaurantSearchFieldWrapperClasses}>
				<SearchField
					onChangeSelectSearchString={changeSearchStringForRestaurants}
					searchString={searchStringForRestaurants}
				/>
			</div>
			<div className={firmwareSearchFieldWrapperClasses}>
				<SearchField onChangeSelectSearchString={changeSearchStringForApk} searchString={searchStringForApk} />
			</div>
		</div>
	);
};

export default SearchFields;
